export default {
  buttons: {
    cancel: "ANNULLÉR",
    dismiss: "Luk",
    add_waypoint: "tilføj destination"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mil"
    }
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Søg",
    placeholder: "Udfyld en lokation",
    enter_location: "Udfyld en lokation",
    help: {
      inactive: "Søg"
    }
  },
  filters: {
    title: "Filter",
    amenities: {
      title: "Services & faciliteter"
    },
    fuels: {
      title: "Typer af brændstof"
    }
  },
  directions: {
    title: "Ruteplanlægger",
    placeholder: {
      destination: "Udfyld en lokation",
      waypoint: "Udfyld en lokation"
    },
    route: {
      title: "Ruteindstillinger",
      avoid_tolls: "Undgå betalingsveje",
      avoid_highways: "Undgå motorveje",
      title_corridor: "Afstand fra rute til Shell-station"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# dag} other {# dage}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# minut} other {# minutter}}\
`,
    button: "Søg"
  },
  locations: {
    title: "lokationer",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} fra {place}"
  },
  open_now: {
    open_24_hours: "Døgnåbent"
  },
  info_window: {
    title: "Stationens detaljer",
    location_id: "Stationsnummer",
    services: "Services & faciliteter",
    nearby: "I nærheden",
    mobile: {
      telephone: "Tlf:"
    },
    opening_hours: {
      title: "Åbningstider",
      mon: "Man.",
      tue: "Tirs.",
      wed: "Ons.",
      thu: "Tors.",
      fri: "Fre.",
      sat: "Lør.",
      sun: "Søn.",
      open_twentyfourhours: "Døgnåbent",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Sidst opdateret",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Ruteplanlægger"
  },
  fuels: {
    fuelsave_midgrade_gasoline: "Shell FuelSave Blyfri 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    low_octane_gasoline: "Shell Blyfri 92",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power Blyfri 99"
  },
  amenities: {
    air_and_water: "Luft",
    austrian_highway_sticker: "Østrigske motorvejsmærker",
    bottled_gas: "BBQ gas flaske",
    carwash: "Bilvask",
    clubsmart_card: "Club smart card",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners Club",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "Kredit kort",
    czech_highway_sticker: "Tjekkiske motorvejsmærker",
    deli2go: "deli2go",
    fleet_card_dkv: "Fleetkort - DKV",
    fleet_card_eni: "Fleetkort - Eni",
    fleet_card_esso: "Fleetkort - Esso",
    fleet_card_general: "Fleetkort",
    fleet_card_uta: "Fleetkort - UTA",
    food_offerings: "Fødevare udbud",
    full_service: "Forpladsservice",
    guarded_car_park: "Bevogtet parkering",
    hgv_lane: "Egnet for lastbiler",
    high_speed_diesel_pump: "High Speed dieselstander",
    hot_food: "Varm mad",
    hungarian_highway_sticker: "Ungarnske motorvejsmærker",
    ido_ticket: "Ido ticket",
    maut_terminal: "Maut Terminal",
    parking_lanes: "Parkering",
    partner_loyalty_accepted: "Accepterer Partner kort",
    pay_at_pump: "Automat",
    self_service: "Selvbetjening",
    service_bay: "Værksted",
    shop: "Butik",
    shower: "Bad",
    slovak_highway_sticker: "Slovakiske motorvejsmærker",
    snack_food: "Fast Food",
    supermarket_fuel_discount: "Brændstof rabat",
    truck_parking: "Lastbil parkering",
    truckport: "Kun lastbiler",
    twenty_four_hour: "Døgnåbent",
    twotheloo: "Toiletter",
    vacuum: "Støvsuger",
    adblue_truck: "AdBlue Pump lastbil",
    adblue_pack: "AdBlue dunke"
  },
  settings: {
    title: "Indstillinger",
    tooltip: "Indstillinger",
    distance_units: {
      title: "Afstand",
      km: "kilometre",
      miles: "mil"
    },
    language: {
      title: "Sprog"
    }
  }
}
